/************
 * Model Class
 * File Name ...: security-target-element.ts
 * Generated By : toji on 07/15/25
 * Date ........: 07/15/25
 ************/
import { ValidationResult } from './validation-result';

export class SecurityTargetElement {
	id: number | null;
	name: string;
	code: string;
	primaryPath: string;
	usedInMultipleAreas: boolean;
	description: string;
	elementType: 'Navigation' | 'Component' | 'Field';
	activeStatus: string;
	optionReadOnly: boolean;
	optionReadWrite: boolean;
	optionExecute: boolean;
	optionShow: boolean;
	parentId: number | null;
	parent?: SecurityTargetElement;

	rightType: string;
	options?: string; 

	constructor() {
		this.id = null;
		this.name = '';
		this.code = '';
		this.primaryPath = '';
		this.usedInMultipleAreas = false;
		this.description = '';
		this.elementType = 'Component';
		this.activeStatus = 'Active';
		this.optionReadOnly = false;
		this.optionReadWrite = false;
		this.optionExecute = false;
		this.optionShow = false;
		this.parentId = null;
		this.parent = undefined;
		this.options = '';
	}

	validateRecord(): ValidationResult {
		const vr = new ValidationResult();

		if (!this.description || this.description.trim().length === 0) {
			vr.focus_field = 'description';
			vr.error = 'Error: Description is required';
			return vr;
		}

		return vr;
	}

}
